module.exports = __webpack_public_path__ + "assets/img/b6f40cad76caffc2b51e01aed5e1364a.svg";